"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class URLModel {
    constructor(object) {
        this.sfDomain = object.sfDomain || '';
        this.contactGroupPrefix = object.contactGroupPrefix || '';
    }
}
URLModel.CONTACT_PREFIX = '003';
exports.URLModel = URLModel;
//# sourceMappingURL=url.model.js.map